// Translations
import error from 'pages/error/translations/tr'
import login from 'pages/login/translations/tr'
import passwordChange from 'pages/password-change/translations/tr'
import register from 'pages/register/translations/tr'
import reset from 'pages/reset/translations/tr'
import termsOfService from 'pages/terms-of-service/translations/tr'
import twoFactorAuthentication from 'pages/two-factor-authentication/translations/tr'
import verification from 'pages/verification/translations/tr'

// Translation: Turkish > Pages
const pages = Object.freeze({
	error,
	login,
	passwordChange,
	register,
	reset,
	termsOfService,
	twoFactorAuthentication,
	verification
})

// Export
export default pages
